const DEFAULT_NEXT_ORDER_LABEL = 'Add to next Autoship order';

const toValidDate = (value: Maybe<string>): Date | null => {
    if (!value) return null;

    const date = new Date(value);

    return Number.isNaN(date.getTime()) ? null : date;
};

/** Formats a next-order date as "Thu, Oct 3" (UTC). Returns `null` for a missing or invalid date. */
export const formatNextOrderDate = (nextSubscriptionDate: Maybe<string>): string | null => {
    const date = toValidDate(nextSubscriptionDate);

    return date
        ? date.toLocaleString('en-US', { month: 'short', day: 'numeric', weekday: 'short', timeZone: 'UTC' })
        : null;
};

export const getAutoshipLabel = (nextSubscriptionDate: Maybe<string>): string => {
    const formattedDate = formatNextOrderDate(nextSubscriptionDate);

    return formattedDate ? `Add to ${formattedDate} order` : DEFAULT_NEXT_ORDER_LABEL;
};
